/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import React from 'react';
import { render } from '../_util/react-render.js';
import Dialog from './Dialog.js';
import { getAttach } from '../_util/dom.js';
import '../_common/js/log/index.js';
import log from '../_common/js/log/log.js';
import '../_chunks/dep-e0370ebe.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-e9b62d1f.js';
import 'react-dom';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-e43cf21c.js';
import '../_chunks/dep-2acfafca.js';
import 'react-transition-group';
import 'classnames';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../config-provider/ConfigContext.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../common/Portal.js';
import '../hooks/useConfig.js';
import '../_util/useSetState.js';
import './defaultProps.js';
import './DialogCard.js';
import '../_chunks/dep-6c5254c6.js';
import 'tdesign-icons-react';
import '../button/index.js';
import '../button/Button.js';
import '../hooks/useDomRefCallback.js';
import '../_util/useRipple.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../loading/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import 'raf';
import '../_util/easing.js';
import '../loading/plugin.js';
import '../loading/style/css.js';
import '../loading/type.js';
import '../button/defaultProps.js';
import '../_util/parseTNode.js';
import '../button/style/css.js';
import '../button/type.js';
import '../hooks/useGlobalIcon.js';
import './hooks/useDialogEsc.js';
import './hooks/useLockStyle.js';
import '../_util/useLayoutEffect.js';
import '../_common/js/utils/getScrollbarWidth.js';
import './hooks/useDialogPosition.js';
import './hooks/useDialogDrag.js';
import './utils.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var createDialog = function createDialog(props) {
  var dialogRef = /*#__PURE__*/React.createRef();
  var options = _objectSpread({}, props);
  var _options$visible = options.visible,
    visible = _options$visible === void 0 ? true : _options$visible;
  var fragment = document.createDocumentFragment();
  render( /* @__PURE__ */React.createElement(Dialog, _objectSpread(_objectSpread({}, options), {}, {
    visible: visible,
    ref: dialogRef,
    isPlugin: true
  })), fragment);
  var container = getAttach(options.attach);
  if (container) {
    container.appendChild(fragment);
  } else {
    log.error("Dialog", "attach is not exist");
  }
  var dialogNode = {
    show: function show() {
      requestAnimationFrame(function () {
        var _dialogRef$current;
        container.appendChild(fragment);
        (_dialogRef$current = dialogRef.current) === null || _dialogRef$current === void 0 ? void 0 : _dialogRef$current.show();
      });
    },
    hide: function hide() {
      requestAnimationFrame(function () {
        var _dialogRef$current2;
        (_dialogRef$current2 = dialogRef.current) === null || _dialogRef$current2 === void 0 ? void 0 : _dialogRef$current2.destroy();
      });
    },
    update: function update(updateOptions) {
      requestAnimationFrame(function () {
        var _dialogRef$current3;
        (_dialogRef$current3 = dialogRef.current) === null || _dialogRef$current3 === void 0 ? void 0 : _dialogRef$current3.update(updateOptions);
      });
    },
    destroy: function destroy() {
      requestAnimationFrame(function () {
        var _dialogRef$current4;
        (_dialogRef$current4 = dialogRef.current) === null || _dialogRef$current4 === void 0 ? void 0 : _dialogRef$current4.destroy();
      });
    }
  };
  return dialogNode;
};
var confirm = function confirm(props) {
  return createDialog(props);
};
var alert = function alert(props) {
  var options = _objectSpread({}, props);
  options.cancelBtn = null;
  return createDialog(options);
};
createDialog.alert = alert;
createDialog.confirm = confirm;
var DialogPlugin = createDialog;

export { DialogPlugin };
//# sourceMappingURL=plugin.js.map
